import Pagination from '@components/common/pagination';
import { PageState } from '@domain/rs/common/PageableRs';
import MatchListCard from './matchListCard';
import MatchingStatusListRq from '@domain/rq/match/MatchingStatusListRq';
import { MatchingStatusVO } from '@domain/vo/match/MatchingStatusListVO';

import classnames from 'classnames/bind';
import styles from './matchList.module.scss';
const cx = classnames.bind(styles);

interface IMatchListProps {
  matchingList: MatchingStatusVO[];
  pageInfo: PageState;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  pageParams: MatchingStatusListRq;
  firstRecommendOrProfileOpenMatchingSn?: number;
  isFirstTooltipVisible: boolean;
  handleTooltipClose: () => void;
}

const MatchList = ({
  matchingList,
  currentPage,
  pageInfo,
  setCurrentPage,
  pageParams,
  firstRecommendOrProfileOpenMatchingSn,
  isFirstTooltipVisible,
  handleTooltipClose,
}: IMatchListProps) => {
  return (
    <div className={cx('container')}>
      {matchingList.map((match) => (
        <MatchListCard
          key={match.matchingSn}
          {...match}
          pageParams={pageParams}
          firstRecommendOrProfileOpenMatchingSn={firstRecommendOrProfileOpenMatchingSn}
          isFirstTooltipVisible={isFirstTooltipVisible}
        />
      ))}

      {pageInfo && pageInfo.totalElements > 5 && (
        <Pagination
          pagesVO={pageInfo}
          currentPage={currentPage}
          setCurrentPage={(page) => {
            setCurrentPage(page);
            handleTooltipClose();
          }}
          isLeftOn={currentPage > 0 ?? false}
          isRightOn={currentPage + 1 < (pageInfo?.totalPages ?? 0) ?? false}
          className={cx('pagination')}
        />
      )}
    </div>
  );
};

export default MatchList;
